module.exports = {"150172401":"如意工业园区","150172402":"金川工业园区","150172403":"呼和浩特出口加工区","150172404":"呼和浩特留学人员创业园","150172405":"沙尔沁工业区（如意南区）","150172406":"呼和浩特白塔空港物流园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150172.json
// module id = 401
// module chunks = 0